module.exports = __webpack_public_path__ + "static/media/1.bede4b8f.png";